import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const tabs = [
  { to: '/admin', label: '\u5185\u5bb9\u7ba1\u7406' },
  { to: '/admin/courseware', label: '\u8bfe\u4ef6\u7ba1\u7406' },
  { to: '/admin/news', label: '\u65b0\u95fb\u7ba1\u7406' },
  { to: '/admin/leads', label: '\u7559\u8a00\u9884\u7ea6' },
  { to: '/admin/brand', label: '\u54c1\u724c\u8bbe\u7f6e' },
];

export default function AdminTabs() {
  const { pathname } = useLocation();
  return (
    <nav className="flex items-center gap-1 rounded-xl bg-gray-100 p-1">
      {tabs.map((t) => {
        const active = pathname === t.to;
        return (
          <Link
            key={t.to}
            to={t.to}
            className={`rounded-lg px-3.5 py-1.5 text-sm transition-colors ${active ? 'bg-white font-semibold text-blue-600 shadow-sm' : 'font-medium text-gray-600 hover:text-blue-600'}`}
          >
            {t.label}
          </Link>
        );
      })}
    </nav>
  );
}
